module.exports = __webpack_public_path__ + "static/media/ico-floating-profile.fac8ae7c.svg";